Router = App.loadClass 'core::Router'

class exports.InserterRouter extends Router

    prefix: 'Inserter'
    module_name: 'InserterRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']
        @controller 'admin::Angular/Inserter/InserterController', [
            '$scope'
            '$http'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'admin.inserter',
                url: '/inserter'
                template: '<div></div>'
                controller: 'Inserter.Controllers.InserterController'
